import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  invalidClass: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
  phoneNumber: {
    whiteSpace: 'nowrap',
    marginInlineStart: theme.spacing(1),
  },
  countryFlag: {
    borderRadius: theme.spacing(0.125),
  },
  invalidTypo: {
    fontSize: theme.spacing(2),
  },
}));
